module.exports = __webpack_public_path__ + "images/sprites/ui/btn_tel_cv_cc324081dff1c77c162b699e549bfab6.png";